import {Form, Formik, FormikProps, useField} from 'formik';
import {useTranslation} from 'react-i18next';
import InnerPop from '../../../../component/newPopup/innerPop/InnerPop';
import Input from '../../../../component/input/Input';
import NumberInput from '../../../../component/input/NumberInput';
import InputList from '../../../../component/input/inputList/InputList';
import {TShow} from '../../../../component/prompotionPopup/PromotionPopup';
import * as css from './PricingPop.css';
import {getPricingValidationSchema} from './PricingPop.validation';
import {useRef} from 'react';
import SingleTicketIcon from '../../../../assets/icons/SingleTicketIcon';
import CoupleTicketsIcon from '../../../../assets/icons/CoupleTicketsIcon';
import FamilyTicketsIcon from '../../../../assets/icons/FamilyTicketsIcon';
import CustomTicketsIcon from '../../../../assets/icons/CustomTicketsIcon';

interface PricingFormValues {
    name: string;
    amount: string;
    price: string;
    ticketsAmount: number;
    manualTicketsAmount: number;
}

function PricingPop({show, onSave, index}: {show: TShow, onSave?: (values: PricingFormValues) => void,  index: number}) {
    const {t} = useTranslation('subscriptions');
    const {t: globalT} = useTranslation('global');
    const formRef = useRef<FormikProps<PricingFormValues>>(null);
    const [{value:priceField},]=useField(`prices[${index}]`);

    const ticketsAmountOptions = [
        {
            key: 1,
            text: t('singleTicketOption'),
            rightChildren: <SingleTicketIcon width={20} height={20} />
        },
        {
            key: 2,
            text: t('coupleTicketOption'),
            rightChildren: <CoupleTicketsIcon width={20} height={20} />
        },
        {
            key: 4,
            text: t('familyTicketOption'),
            rightChildren: <FamilyTicketsIcon width={20} height={20} />
        },
        {
            key: 0,
            text: t('customTicketOption'),
            rightChildren: <CustomTicketsIcon width={20} height={20} />
        }
    ];

    const validationSchema = getPricingValidationSchema(globalT);

    // Mapping object for ticketsAmount to manualTicketsAmount
    const ticketsAmountMapping: Record<number, string> = {
        1: ticketsAmountOptions[0].text,
        2: ticketsAmountOptions[1].text,
        4: ticketsAmountOptions[2].text,
    };

    const initialValues: PricingFormValues = {
        name: priceField?.name??null,
        amount: priceField?.amount ??null,
        price: priceField?.price??null,
        manualTicketsAmount: priceField?.ticketsAmount??null,
        ticketsAmount: priceField?.ticketsAmount
    };


    const handleSave = (values: PricingFormValues) => {
        if(onSave) {
            onSave(values);
        }
        show.close();
    };

    const handleCancel = () => {
        formRef.current?.resetForm();
        show.close();
    };

    return (
        <css.pricingPop>
            <Formik
                innerRef={formRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSave}
            >
                {({values, setFieldValue}) => {
                    const handleTicketsAmountChange = (name, value) => {
                        const key = Number(value);
                        setFieldValue('ticketsAmount', key);
                        // אם לא custom, עדכן את manualTicketsAmount לאותו ערך
                        if (key !== 0) {
                            setFieldValue('manualTicketsAmount', key);
                        }
                    };

                    return (
                        <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <InnerPop
                                dataCy='pricing'
                                show={show}
                                title={t('pricing')}
                                buttons={{
                                    whiteBtn: {
                                        text: t('cancel'),
                                        onClick: handleCancel
                                    },
                                    blueBtn: {
                                        text: t('save'),
                                        onClick: () => formRef.current?.submitForm()
                                    }
                                }}
                            >
                                <css.header />
                                <css.content>
                                    <Input
                                        name='name'
                                        text={t('pricingName')}
                                        description={t('pricingNameDescription')}
                                        icon={null}
                                        events={{}}
                                        className=''
                                        forwardRef={null}
                                    />
                                    <NumberInput
                                        name='price'
                                        text={t('price')}
                                        icon={null}
                                        className=''
                                        forwardRef={null}
                                    />
                                    <InputList
                                        name='ticketsAmount'
                                        list={ticketsAmountOptions}
                                        text={t('ticketsAmount')}
                                        description={values.ticketsAmount === 0 ? '' : t('ticketsAmountDescription', {amount: values.ticketsAmount})}
                                        icon={null}
                                        className=''
                                        valid={true}
                                        onFocus={() => {}}
                                        onChange={handleTicketsAmountChange}
                                    >
                                        {''}
                                    </InputList>
                                    <NumberInput
                                        name='manualTicketsAmount'
                                        text={t('manualTicketsAmount')}
                                        icon={null}
                                        className=''
                                        forwardRef={null}
                                        disabled={values.ticketsAmount !== 0}
                                    />
                                </css.content>
                            </InnerPop>
                        </Form>
                    );
                }}
            </Formik>
        </css.pricingPop>
    );
}

export default PricingPop;

